import React from 'react';
import CommonHeader from '@/components/CommonHeader';
import $i18n from '@/i18n';

const breadcrumbConfig = [
  {
    key: 'miniAppStore',
    breadcrumbName: $i18n.get({
      id: 'aopf.pages.channel.channelList.header.title',
      dm: '小程序商店',
    }),
    path: '/miniAppStore',
  },
];
const ChannelHeader: React.FC = () => {
  return (
    <div>
      <CommonHeader
        title={$i18n.get({ id: 'aopf.pages.channel.channelList.header.title', dm: '小程序商店' })}
        // backTo={`/miniAppStore${location.search}`}
        breadcrumbs={breadcrumbConfig}
      />
    </div>
  );
};
export default ChannelHeader;
